export const getPdfSingFeild = (createmode, signInputfield) => {
	if (
		createmode === 'false'
		&& window.location.pathname !== '/templatepreview'
	) {
		for (const item of signInputfield) {
			const checkElm = window.document.querySelector(
				'#signinput' + item.inputId
			);
			const currentDate = new Date().toLocaleDateString();
			if (checkElm) {
				checkElm.innerHTML = `Signed by : ${item.value} - ${currentDate}`;
				continue;
			}

			const createInputTag = window.document.createElement('span');

			createInputTag.innerHTML = `Signed by : ${item.value} - ${currentDate}`;
			createInputTag.style.display = 'block';
			createInputTag.style.fontSize = '12px';
			createInputTag.setAttribute('id', 'signinput' + item.inputId);
		}
	}
};

export const getSignFields = (createmode, singedFields) => {
	if (createmode === 'false') {
		const getEsignInputsfromPage
			= window.document.querySelectorAll('.template-esign');

		for (const item of singedFields) {
			for (const element of getEsignInputsfromPage) {
				if (element.getAttribute('id') === item.inputId) {
					element.setAttribute('value', item?.value);
					element.dataset.recp = item?.id;
					element.style.width = `${(item?.value?.length || 0) * 11}px`;
				} else {
					element.setAttribute('name', element.getAttribute('name'));
				}
			}
		}
	}
};

export const fillRecipientsInput = (createmode, filledRecipients) => {
	if (createmode === 'false') {
		const getRecipientInputsfromPage = window.document.querySelectorAll(
			'.template-recipient'
		);

		for (const item of filledRecipients) {
			for (const element of getRecipientInputsfromPage) {
				if (element) {
					if (element.getAttribute('name') === item?.name) {
						element.setAttribute('value', item?.inval);
					} else if (element.getAttribute('id') === item?.inputId) {
						element.setAttribute('value', '');
					}
				}
			}
		}
	}
};
